<template>
  <div @click='doNav()' v-if='!isRoot' class="mr-2">
      <!-- <img class='flip-90' style="height:40px;width:40px;" src='../../../static/assets/img/icon-arrow-down.png' /> -->
      <i class="fa fa-angle-left text-primary"></i>
  </div>
</template>

<script>
export default {
    name: 'pluginSiteNav',
    methods: {
        doNav(){
            console.log('this.$router', this.$router)
            console.log('this.$route', this.$route)
            if(this.$route.name == 'Plugin.CustomerProfile'){
                this.$router.push({name: 'Plugin.CustomerList'})
            }
            else if(this.$route.name == 'Plugin.CustomerList'){
                this.$router.push({name: 'Plugin.PluginNav'})
            }
        }
    },
    computed: {
        isRoot: function (){
            if(this.$route.name == 'Plugin.PluginNav'){
                return true
            }
            else
            {
                return false
            }
        }
    },
    mounted: function (){
        console.log(this.$route)
    }
}
</script>

<style lang="scss" scoped>
.fa {
  // display: inline-block;
  font-size: 25px;
  line-height: 27px;
  width: 20px;
  text-align: left;
  vertical-align: bottom;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/Nav/PluginSiteNav.vue